import React, { Ref, useMemo } from 'react';
import clsx from 'clsx';
import * as classes from './Copy.module.scss';

interface ICopyProps<T extends 'p'|'div'> {
    small?: boolean;
    center?: boolean;
    as?: T;
}

export const Copy = React.forwardRef(<
        T extends 'p'|'div',
        E extends HTMLElement = HTMLElementTagNameMap[T]
    >(
        props: React.HTMLProps<E> & ICopyProps<T>,
        ref: Ref<E> | undefined
    ) => {
    const { as: Comp = 'div', className, small, center, ...rest } = props;
    const mergedClassName = useMemo(() => {
        return clsx(className, small ? classes.small : classes.copy, center && classes.center);
    }, [ small, center, className ]);

    // @ts-ignore
    return <Comp ref={ref} className={mergedClassName} {...rest} />;
});
Copy.displayName = 'Copy';
